import ApolloClient from "apollo-boost";

// export let uri = 'http://localhost';
// export let uri = 'https://api.sandbox.usezapay.com.br';
export let uri = 'https://api.usezapay.com.br';
// export let uri = 'http://api-test.staging.usezapay.com.br';

if (process.env.REACT_APP_ENV === 'staging') {
    uri = 'https://api.staging.usezapay.com.br';
}
else if (process.env.REACT_APP_ENV === 'production') {
    uri = 'https://api.usezapay.com.br';
}
else if (process.env.REACT_APP_ENV === 'sandbox') {
    uri = 'https://api.sandbox.usezapay.com.br';
}

else if (process.env.REACT_APP_ENV === 's2') {
    uri = 'https://api.s2.usezapay.com.br';
}

export const client = new ApolloClient({
    uri: `${uri}/graphql/`,
    fetchOptions: {
        credentials: 'include'
    },
    request: async (operation) => {
        const token = await sessionStorage.getItem('token');
        operation.setContext({
            headers: {
                authorization: token ? `JWT ${token}` : ''
            }
        });
    }
});



// WEBPACK FOOTER //
// ./src/apollo.js